module.exports = __webpack_public_path__ + "img/links.c122267d.svg";